import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { useNavigate, useParams } from 'react-router-dom'
import { FOND_MODES } from '../../../../util/functions'
import BackButton from '../../../../component/common/Back-Button';

const PetModeFeedback = () => {
    const { id, historyId } = useParams()
    const navigate = useNavigate()

    return (
        <>
            <div>
                <Card className="my-5">
                    <BackButton onClick={() => navigate(`/app/pets/${id}`, { state: { active: "mode" } })} />
                    <Heading>Mode FeedBack</Heading>


                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Mode_User_Feedback.getAll,
                                extraQuery: { modeHistoryId: historyId },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `MF${data?.id.toString().padStart(7, "0")}`,
                                            modeD: FOND_MODES[data?.modeFeedbackQuestion?.mode] || '-',
                                            userName: data?.user?.name,
                                            question: data?.modeFeedbackQuestion?.question,
                                            optionsD: <>
                                                <div>Option 1 : <span className='font-semibold'> {data?.modeFeedbackQuestion?.options[0]} </span></div>
                                                <div>Option 2 : <span className='font-semibold'> {data?.modeFeedbackQuestion?.options[1]} </span></div>
                                                <div>Option 3 : <span className='font-semibold'> {data?.modeFeedbackQuestion?.options[2]} </span></div>
                                                <div>Option 4 : <span className='font-semibold'> {data?.modeFeedbackQuestion?.options[3]} </span></div>
                                            </>,

                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.MODE_FEEDBACK_PET,
                            }}
                            isSearch={true}
                            FILTERSORTKEY={
                                { "modeD": 'mode' }
                            }

                        />
                    </Row>
                </Card>
            </div>
        </>
    )
}

export default PetModeFeedback